import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'

import '@/styles/index.scss'

Vue.use(ElementUI, { size: 'small' })

// 品项分类显示名映射（内部编码保持不变，仅显示名可配置）
import { catName, catColor } from '@/utils/itemCategory'
Vue.filter('catName', catName)
Vue.prototype.$catName = catName
Vue.prototype.$catColor = catColor

// 手机号脱敏（跟随后台 privacyMobileMask）
import { formatMobileDisplay } from '@/utils/mobile-mask'
Vue.prototype.$maskMobile = function(mobile) {
  return formatMobileDisplay(mobile, this.$store.getters.privacyMobileMask)
}
Vue.filter('maskMobile', function(mobile) {
  // eslint-disable-next-line global-require
  const s = require('./store').default
  return formatMobileDisplay(mobile, s.getters.privacyMobileMask)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
